import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { useTranslation } from 'react-i18next';

import { tableNoPaginationOptions } from '../../../component/helpers/table';
import { formatTimestamp, formatTimeInHMS } from '../../helpers/tablesFuncHelpers';
import CustomButton from '../../../component//CustomButton';
import '../../../component/dump/menuComponents/menuComponents.sass';

const StopReportBSTable = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'reportsPage.standardReportData' });
	const { data } = props;
	const [expand, setExpand] = useState(data);
	const navigate = useNavigate();

	useEffect(() => {
		setExpand(data);
	}, [data]);

	const formatGeofencing = (cell) => {
		if (Array.isArray(cell) && cell.length) {
			const names = cell.map((item) => Object.values(item || {}).join(', ')).filter(Boolean).join(', ');
			return names || 'No';
		}

		if (typeof cell === 'string' && cell.trim()) {
			return cell;
		}

		return 'No';
	};

	const formatException = (cell, row) => {
		if (cell) {
			return cell;
		}

		return (row.duration || 0) >= 1800 ? t('Long_Stops') : '-';
	};

	const formatMapView = (cell, row) => {
		if (row.lat === undefined || row.lng === null) {
			return '-';
		}

		return (
			<div className="map-view-link">
				<CustomButton
					variant="link"
					onClick={() => navigate('/', {
						state: { id: row.device_id, lat: row.lat, lng: row.lng, type: 'reports' },
					})}
				>
					{t('View')}
				</CustomButton>
			</div>
		)
	};

	return (
		<div className="expanded-wrapper">
			<div className="expanded-body">
				<BootstrapTable
					data={expand}
					{...tableNoPaginationOptions}
				>
					<TableHeaderColumn
						dataField="start_ts"
						width="12%"
						isKey
						dataSort
						dataFormat={formatTimestamp}
					>
						{t('headerStart')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="12%"
						dataField="end_ts"
						dataSort
						dataFormat={formatTimestamp}
					>
						{t('headerEnd')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="10%"
						dataField="duration"
						dataFormat={formatTimeInHMS}
						dataSort
					>
						{t('headerDuration')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="15%"
						dataField="address"
						dataSort
					>
						{t('headerLocation')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="12%"
						dataField="type"
						dataSort
					>
						{t('headerType')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="17%"
						dataField="geofencing"
						dataFormat={formatGeofencing}
						dataSort
					>
						{t('headerGeofence')}
					</TableHeaderColumn>
					<TableHeaderColumn
						width="12%"
						dataField="exception"
						dataSort
						dataFormat={formatException}
						tdStyle={{ whiteSpace: 'normal' }}
					>
						{t('headerException')}
					</TableHeaderColumn>
					{/* <TableHeaderColumn
						width="10%"
						dataField="id"
						dataFormat={formatMapView}
						csvFormat={formatMapView}
					>
						{t('headerMap')}
					</TableHeaderColumn> */}
				</BootstrapTable>
			</div>
		</div>
	)
}

export default connect(
	null,
	dispatch => ({
		toggleLoader: (show) => {
			dispatch({ type: 'TOGGLE_LOADER', payload: show });
		}
	})
)(StopReportBSTable);
